module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hKZs8"))).then(() => parcelRequire('3a9aZ'));